/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  DeleteConfigRequestBody,
  DeleteConfigRequestBody$Outbound,
  DeleteConfigRequestBody$outboundSchema,
} from "../components/deleteconfigrequestbody.js";

export type DeleteDeviceIntegrationConfigSecurity = {
  apikeyHeaderGramKey?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type DeleteDeviceIntegrationConfigRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  deleteConfigRequestBody: DeleteConfigRequestBody;
};

/** @internal */
export type DeleteDeviceIntegrationConfigSecurity$Outbound = {
  "apikey_header_Gram-Key"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const DeleteDeviceIntegrationConfigSecurity$outboundSchema:
  z.ZodMiniType<
    DeleteDeviceIntegrationConfigSecurity$Outbound,
    DeleteDeviceIntegrationConfigSecurity
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.optional(z.string()),
      sessionHeaderGramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function deleteDeviceIntegrationConfigSecurityToJSON(
  deleteDeviceIntegrationConfigSecurity: DeleteDeviceIntegrationConfigSecurity,
): string {
  return JSON.stringify(
    DeleteDeviceIntegrationConfigSecurity$outboundSchema.parse(
      deleteDeviceIntegrationConfigSecurity,
    ),
  );
}

/** @internal */
export type DeleteDeviceIntegrationConfigRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  DeleteConfigRequestBody: DeleteConfigRequestBody$Outbound;
};

/** @internal */
export const DeleteDeviceIntegrationConfigRequest$outboundSchema: z.ZodMiniType<
  DeleteDeviceIntegrationConfigRequest$Outbound,
  DeleteDeviceIntegrationConfigRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    deleteConfigRequestBody: DeleteConfigRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      deleteConfigRequestBody: "DeleteConfigRequestBody",
    });
  }),
);

export function deleteDeviceIntegrationConfigRequestToJSON(
  deleteDeviceIntegrationConfigRequest: DeleteDeviceIntegrationConfigRequest,
): string {
  return JSON.stringify(
    DeleteDeviceIntegrationConfigRequest$outboundSchema.parse(
      deleteDeviceIntegrationConfigRequest,
    ),
  );
}
